import React from "react"
import Grid from "./../grid"
import H1 from "./../typography/h1"
import H2 from "./../typography/h2"
import P from "./../typography/p"
import PropTypes from "prop-types"
import { StyledPlacementOffer, Img } from "./styles"
import { H3 } from "../typography"
import Moment from "../moment"

class PlacementOffer extends React.Component {
  render() {
    const { employer, participant, placement, header_1, content_1, header_2, content_2 } = this.props

    const employerDetails = (
      <Grid gap="1rem">
        <H2 variant="primary" marginless>
          {employer.host_word} Details
        </H2>

        <Grid grid="auto / auto-flow" placeItems="start" placeContent="start">
          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              {employer.host_word} Name
            </H3>
            <P marginless={true} wrap={true} variant="content">
              {employer.name}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Address
            </H3>
            <P marginless={true} wrap={true} variant="content">
              {employer.address && Object.keys(employer.address).length > 0 && (
                <>
                  {employer.address.address_1}
                  <br />
                  {employer.address.address_2 && (
                    <>
                      {employer.address.address_2}
                      <br />
                    </>
                  )}
                  {employer.address.town}
                  <br />
                  {employer.address.county && (
                    <>
                      {employer.address.county}
                      <br />
                    </>
                  )}
                  {employer.address.country}
                </>
              )}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Phone
            </H3>
            {employer.address && Object.keys(employer.address).length > 0 && (
              <P marginless={true} wrap={true} variant="content">
                {employer.address.phone}
              </P>
            )}
          </Grid>

          {!!employer.website && (
            <Grid gap="0.5rem">
              <H3 variant="primary" marginless>
                Website
              </H3>
              <P marginless={true} wrap={true} variant="content">
                {employer.website}
              </P>
            </Grid>
          )}
        </Grid>
      </Grid>
    )

    const participantDetails = (
      <Grid gap="1rem">
        <H2 variant="primary" marginless>
          Participant Details
        </H2>

        <Grid grid="auto / auto-flow" placeItems="start" placeContent="start">
          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Name
            </H3>
            <P marginless={true} variant="content">
              {participant.full_name}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Date of Birth
            </H3>
            <P marginless={true} variant="content">
              <Moment value={participant.dob} />
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Address
            </H3>
            <P marginless={true} wrap={true} variant="content">
              {participant.address.address_1}
              <br />
              {participant.address.address_2 && (
                <>
                  {participant.address.address_2}
                  <br />
                </>
              )}
              {participant.address.town}
              <br />
              {participant.address.county && (
                <>
                  {participant.address.county}
                  <br />
                </>
              )}
              {participant.address.country}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Phone
            </H3>
            <P marginless={true} wrap={true} variant="content">
              {participant.address.phone}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Email
            </H3>
            <P marginless={true} wrap={true} variant="content">
              {participant.email}
            </P>
          </Grid>
        </Grid>
      </Grid>
    )

    const placementDetails = (
      <Grid gap="1rem">
        <H2 variant="primary" marginless>
          Placement Information
        </H2>

        <Grid grid="auto / auto-flow" placeItems="start" placeContent="start">
          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Position
            </H3>
            <P marginless={true} variant="content">
              {placement.position}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Program
            </H3>
            <P marginless={true} variant="content">
              {placement.programme_name}
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Arrival Date
            </H3>
            <P marginless={true} variant="content">
              <Moment value={placement.starts_on} />
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Start Date
            </H3>
            <P marginless={true} variant="content">
              <Moment value={placement.contract_starts_on} />
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              End Date
            </H3>
            <P marginless={true} variant="content">
              <Moment value={placement.ends_on} />
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              No. of Days
            </H3>
            <P marginless={true} variant="content">
              {placement.number_of_days}
            </P>
          </Grid>
        </Grid>

        <Grid grid="auto / auto-flow" placeItems="start" placeContent="start">
          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              Placement Offer - Issue Date
            </H3>
            <P marginless={true} variant="content">
              <Moment value={placement.offer_date} />
            </P>
          </Grid>

          <Grid gap="0.5rem">
            <H3 variant="primary" marginless>
              {placement.pay_label}
            </H3>
            <P marginless={true} variant="content">
              {placement.pay_value}
            </P>
          </Grid>
        </Grid>
      </Grid>
    )

    return (
      <StyledPlacementOffer>
        {!!employer.host_word && (
          <>
            <Grid placeItems="center" placeContent="center" gap="1rem" mobile>
              <Img src={employer.avatar} alt="Placement Offer" />
              <H1 variant="primary">{employer.name} Placement Offer</H1>
            </Grid>

            <Grid gap="3rem">
              {employerDetails}
              {participantDetails}
              {placementDetails}

              <Grid gap="0.5rem">
                <H2 variant="primary" marginless>
                  {header_1}
                </H2>
                <P variant="content" wrap={true} marginless={true}>
                  {content_1}
                </P>
              </Grid>

              <Grid gap="0.5rem">
                <H2 variant="primary" marginless>
                  {header_2}
                </H2>
                <P variant="content" wrap={true} marginless={true}>
                  {content_2}
                </P>
              </Grid>
            </Grid>
          </>
        )}
      </StyledPlacementOffer>
    )
  }
}

PlacementOffer.propTypes = {
  employer: PropTypes.object.isRequired,
  participant: PropTypes.object.isRequired,
  placement: PropTypes.object.isRequired,
  header_1: PropTypes.string.isRequired,
  header_2: PropTypes.string.isRequired,
  content_1: PropTypes.string.isRequired,
  content_2: PropTypes.string.isRequired
}

PlacementOffer.defaultProps = {
  employer: { address: {} },
  participant: { address: {} },
  placement: {},
  header_1: "",
  header_2: "",
  content_1: "",
  content_2: ""
}

export default PlacementOffer
